import { render, staticRenderFns } from "./IdentificationPhotos.vue?vue&type=template&id=417375d4&scoped=true"
import script from "./IdentificationPhotos.vue?vue&type=script&lang=js"
export * from "./IdentificationPhotos.vue?vue&type=script&lang=js"
import style0 from "./IdentificationPhotos.vue?vue&type=style&index=0&id=417375d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417375d4",
  null
  
)

export default component.exports